import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Button,
  ButtonModel,
  IconRegularChevronRight,
  useBreakpointValue,
} from '@notino/react-styleguide';

import { ContentWrapper } from '@components';
import { Flex } from '@components/Flex';
import {
  RICH_CONTENT_SECTION_ID,
  REVIEW_SECTION_ID,
} from '@containers/ReviewsPage/constants';
import { useReviewsPageStore } from '@containers/ReviewsPage/store';

import { messages } from '../messages';

import {
  WhiteBlock,
  WhiteBlockAnnotation,
  WhiteBlockFlex,
  WhiteBlockTitle,
} from './styled';
import { useStickyBarWithinLayoutMainWrap } from './useStickyBarWithinLayoutMainWrap';

type Props = {
  annotation: string;
  productName: string;
  redirectUrl: string;
  hasRichContent: boolean;
  handleBuyLinkClicked: () => void;
};

export const StickyBar = ({
  annotation,
  productName,
  redirectUrl,
  hasRichContent,
  handleBuyLinkClicked,
}: Props) => {
  const { isRichContentInView } = useReviewsPageStore();
  const { ref: stickyBarRef, isVisible } = useStickyBarWithinLayoutMainWrap({
    hideOffsetPx: 12,
  });
  const buttonSize = useBreakpointValue({
    xs: ButtonModel.Sizes.small,
    md: ButtonModel.Sizes.default,
  });

  return (
    <WhiteBlock
      ref={stickyBarRef}
      style={{
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? 'auto' : 'none',
      }}
    >
      <ContentWrapper>
        <WhiteBlockFlex>
          <WhiteBlockTitle>
            {productName}
            <WhiteBlockAnnotation>{annotation}</WhiteBlockAnnotation>
          </WhiteBlockTitle>

          <Flex gap="8px">
            {hasRichContent && (
              <Button
                href={`#${
                  isRichContentInView
                    ? REVIEW_SECTION_ID
                    : RICH_CONTENT_SECTION_ID
                }`}
                buttonStyle={ButtonModel.Styles.secondary}
                buttonSize={buttonSize}
              >
                <Flex gap="6px" align="center">
                  {isRichContentInView ? (
                    <FormattedMessage {...messages.yourReviewsButton} />
                  ) : (
                    <FormattedMessage {...messages.rcButton} />
                  )}
                  <IconRegularChevronRight width="20px" height="20px" />
                </Flex>
              </Button>
            )}
            <Button
              onClick={handleBuyLinkClicked}
              href={redirectUrl}
              buttonSize={buttonSize}
            >
              <FormattedMessage {...messages.showProductDetail} />
            </Button>
          </Flex>
        </WhiteBlockFlex>
      </ContentWrapper>
    </WhiteBlock>
  );
};
